"use client";

import {
  getDesktop,
  getMargins,
  getMobile,
  getPaddings,
  getRounded,
} from "@/utils/theme-helper";

export interface TypographyComponentProps {
  text: string;
  size: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "4xl";
  bgColor: string;
  textColor: string;
  padding: string;
  margin: string;
  align: "center";
  height: string;
  width: string;
  rounded: string;
}

const TypographyComponent: React.FC<{
  config: TypographyComponentProps;
}> = ({ config: typography }) => {
  const mobileWidth = getMobile("none", typography.width);
  const desktopWidth = getDesktop("none", typography.width);
  const mobileHeight = getMobile("none", typography.height);
  const desktopHeight = getDesktop("none", typography.height);

  return (
    <div
      style={
        {
          color: typography.textColor,
          backgroundColor: typography.bgColor,
          textAlign: typography.align,
          "--mobile-width": mobileWidth,
          "--desktop-width": desktopWidth,
          "--mobile-height": mobileHeight,
          "--desktop-height": desktopHeight,
        } as React.CSSProperties
      }
      dangerouslySetInnerHTML={{ __html: typography.text }}
      className={`styled-description homepage-text-${typography?.size ?? "sm"} ${getMargins(typography.margin)} ${getPaddings(typography.padding)} ${mobileWidth !== "none" ? "w-[var(--mobile-width)]" : ""} ${desktopWidth !== "none" ? "md:w-[var(--desktop-width)]" : ""} ${mobileHeight !== "none" ? "h-[var(--mobile-height)]" : ""} ${desktopHeight !== "none" ? "md:h-[var(--desktop-height)]" : ""} ${getRounded(typography.rounded)} overflow-hidden`}
    ></div>
  );
};

export default TypographyComponent;
